import {
  SelectOwnerContractFrequencyPaymentMenu,
  SelectOwnerContractLeaseTypeStep,
  SelectOwnerContractOwnerMenu,
  SelectOwnerContractPropertyMenu,
  SelectOwnerContractAmountMenu,
  SelectOwnerContractInsuranceMenu,
  SelectOwnerContractSummary,
  SelectOwnerContractDatesMenu
} from '../organism';

type CreateOwnerContractTemplateProps = {
  step: number;
};

export const CreateOwnerContractTemplate = ({
  step,
}: CreateOwnerContractTemplateProps) => {
  return (
    <div className="w-full">
      {(() => {
        switch (step) {
          case 0:
            return <SelectOwnerContractOwnerMenu />;
          case 1:
            return <SelectOwnerContractPropertyMenu />;
          case 2:
            return <SelectOwnerContractLeaseTypeStep />;
          case 3:
            return <SelectOwnerContractFrequencyPaymentMenu />;
          case 4:
            return <SelectOwnerContractDatesMenu />;
          case 5:
            return <SelectOwnerContractAmountMenu />;
          case 6:
            return <SelectOwnerContractInsuranceMenu />;
          case 7:
            return <SelectOwnerContractSummary />;
          default:
            return null;
        }
      })()}
    </div>
  );
};
